/**
 * ChatSkeleton — alternating bubble placeholders for a conversation whose
 * history is still loading (direct chat and Robi).
 */
import { Skeleton, SkeletonGroup, skeletonKeys } from '../../components/ui/Skeleton';
import './messages.css';

interface ChatSkeletonProps {
  bubbles?: number;
}

export function ChatSkeleton({ bubbles = 6 }: ChatSkeletonProps) {
  return (
    <SkeletonGroup className="chat-skeleton">
      {skeletonKeys(bubbles).map((key, index) => (
        <Skeleton
          key={key}
          shape="rect"
          className={`chat-skeleton__bubble chat-skeleton__bubble--${index % 2 === 0 ? 'received' : 'sent'}`}
        />
      ))}
    </SkeletonGroup>
  );
}
